import { axiosInstance, downloadBlobDataFile } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * [출고주문관리 > 출고주문조회] 엑셀 양식 다운로드 API
 */
const useGetOrderDefaultExcel = () => {
  const endPoint = '/api-oms/order/default-excel';

  const getOrderDefaultExcel = async () => {
    return axiosInstance
      .get(endPoint, {
        responseType: 'blob',
        headers: {
          Accept: 'application/octet-stream',
        },
      })
      .then((data) => {
        downloadBlobDataFile(data);
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { getOrderDefaultExcel };
};

export default useGetOrderDefaultExcel;
